import { observer } from 'mobx-react-lite'
import { ContactsHistory } from 'pages/contacts/pages/history/ui/ContactsHistory'

export const HistoryPage = observer(() => {
  return <ContactsHistory />
})
